// ===========================================================================
// CDCI — Clinical Documentation & Charge Intelligence
// Módulo Etapa 2 (docs/modulos/BillingV2/02_CDCI_Descripcion_Modulo.md).
// Acompaña al médico en el ciclo completo de la cita: agenda → contexto →
// nota → cargos → firma. AdvancedMD sigue siendo el source of truth.
// ===========================================================================
import React from "react";
import CdciSchedulePage from "./pages/CdciSchedulePage";
import CdciEncounterPage from "./pages/CdciEncounterPage";
import { CDCI_BASE_PATH } from "./common/constants";

export const cdciRoutes = [
  { path: CDCI_BASE_PATH, element: <CdciSchedulePage /> },
  { path: `${CDCI_BASE_PATH}/encounter/:appointmentId`, element: <CdciEncounterPage /> },
];

export { CdciSchedulePage, CdciEncounterPage };
export { CDCI_BASE_PATH } from "./common/constants";
